import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {
    gerProcessCategoriesData() {
        var msgType = "fetchSuccess";
        return axios.get(constants.BASE_URL + "/categories", {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "fetchError";
            })
            .finally(() => {
                if (msgType == 'fetchError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching process categories"
                    });
                }
            });
    },
    saveCategory(processCategory, isEdit) {
        axios.defaults.withCredentials = true;

        let url = constants.BASE_URL + "/categories";
        if(isEdit) {
            return axios.put(url, processCategory)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error.response.data;
            })
        } else {
            return axios.post(url, processCategory)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error.response.data;
            })
        }
    },
    checkforProcessCriterias(category) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/categories/process", category)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error.response.data;
            })
    },
    deleteCategory(categoryId) {
        axios.defaults.withCredentials = true;

        return axios.delete(constants.BASE_URL + "/categories/" + categoryId)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                let notification = {
                    "msg": "Error"
                }
                EventBus.$emit('error-notification', notification);
            })
    }
}